/**
 * @generated SignedSource<<1961327474d06151014566bb4cfbbf51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchShortcutColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "%future added value";
export type SearchShortcutIcon = "ALERT" | "ARCHIVE" | "BEAKER" | "BOOKMARK" | "BRIEFCASE" | "BUG" | "CALENDAR" | "CLOCK" | "CODESCAN" | "CODE_REVIEW" | "COMMENT" | "COMMENT_DISCUSSION" | "COPILOT" | "DEPENDABOT" | "EYE" | "FILE_DIFF" | "FLAME" | "GEAR" | "GIT_PULL_REQUEST" | "GLOBE" | "HOME" | "HUBOT" | "INBOX" | "ISSUE_OPENED" | "LINK" | "MENTION" | "METER" | "MOON" | "NORTH_STAR" | "ORGANIZATION" | "PEOPLE" | "PERSON" | "REPO" | "REPO_FORKED" | "REPO_LOCKED" | "REPO_TEMPLATE" | "ROCKET" | "SMILEY" | "SQUIRREL" | "STAR" | "SUN" | "TELESCOPE" | "TERMINAL" | "TOOLS" | "ZAP" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type DashboardSearchBarActionsFragment$data = {
  readonly color: SearchShortcutColor;
  readonly description: string;
  readonly icon: SearchShortcutIcon;
  readonly id: string;
  readonly name: string;
  readonly query: string;
  readonly " $fragmentType": "DashboardSearchBarActionsFragment";
};
export type DashboardSearchBarActionsFragment$key = {
  readonly " $data"?: DashboardSearchBarActionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardSearchBarActionsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardSearchBarActionsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "query",
      "storageKey": null
    }
  ],
  "type": "Shortcutable",
  "abstractKey": "__isShortcutable"
};

(node as any).hash = "682b1e8a44de9aaf4d1a1b28c4aa0972";

export default node;
